import clsx from "clsx";

const getImageClassName = (selected: boolean) => {
  const baseStyles = "absolute top-1/2 left-1/2 h-[12rem]";

  return clsx(
    baseStyles,
    selected &&
      "animate-inwards duration-[0.8s] translate-x-[-50%] translate-y-[-50%] scale-100 opacity-100",
    !selected &&
      "-translate-x-[300%] -translate-y-1/2 scale-[60%] opacity-0 transition-[transform,opacity] duration-[600ms]",
  );
};

export type IllustrationsProps = {
  illustrations: string[];
  active?: number;
};

export const Illustrations = ({ illustrations, active }: IllustrationsProps) =>
  active === undefined ? null : (
    <div className="relative m-4 h-[12rem] w-[12rem] grow-0 shrink-0 basis-[12rem]">
      {illustrations.map((src, index) => (
        <img
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          src={src}
          aria-selected={index === active}
          alt=""
          className={getImageClassName(index === active)}
        />
      ))}
    </div>
  );
